module.exports = __webpack_public_path__ + "static/banner-services-desktop-3c1fef72bac19447d4fd83b4e356270d.jpg";